import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PublicDocument } from "@/components/legal/public-document";

/**
 * Публичный текст документа — `/legal/<key>`.
 *
 * Адрес пригоден для письма и футера: работает без сессии, принимает локаль
 * параметром и не зависит от того, куда человек шёл до этого.
 */
const searchSchema = z.object({
	/**
	 * ISO 639-1. Мусор отбрасываем — страница обязана открыться в любом случае.
	 *
	 * Имя параметра — `lang`, ровно то же, что слушает детектор i18next
	 * (`packages/shared/src/i18n`). Раньше здесь стоял `locale`, и один и тот же
	 * язык назывался в адресе двумя словами: ссылка из письма переключала текст
	 * документа, но не интерфейс вокруг него.
	 */
	lang: z
		.string()
		.regex(/^[a-z]{2}$/)
		.optional(),
});

export const Route = createFileRoute("/legal/$key")({
	validateSearch: (input: Record<string, unknown>) => searchSchema.safeParse(input).data ?? {},
	component: DocumentScreen,
});

function DocumentScreen() {
	const { key } = Route.useParams();
	const { lang } = Route.useSearch();
	return <PublicDocument documentKey={key} locale={lang} />;
}
